<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="container-fluid">
  <p-confirmDialog class="confirm-message" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warning" appendTo="body"></p-confirmDialog>
  <div class="row">
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class="row m-0 p-0">
          <div class="col-11" id="multiselectDiv">
            <div class="ui-inputgroup mb-0" id="filterLabel">
              <button pButton class="theme-button noHover labelButton" type="button" label="Filter"></button>
              <p-multiSelect [options]="filterOptions" (onChange)="onApplyFilter()" [(ngModel)]="selectedStatuses" optionLabel="label" optionValue="value"
                [filter]="true" filterBy="label" id="multiselectStatuses" [maxSelectedLabels]="1" placeholder="Sel. Status"
                styleClass="multiSelectionDropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>

          <div class="col-1" id="refreshBatchesDiv">
            <button pButton class="refreshBatches" *ngIf="checkBeadChipLoadingTabActive()" icon="fa fa-refresh" (click)="onApplyFilter()"></button>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-11 pt-2" id="multiselectDiv">
            <div class="ui-inputgroup mb-0" id="filterLabel">
              <button pButton class="theme-button noHover labelButton" type="button" label="Protocol"></button>
              <p-multiSelect [options]="protocolsList" name="processFlowsList" (onChange)="onApplyFilter()"
                [(ngModel)]="selectedProtocolList" optionLabel="label" optionValue="value" [filter]="true" filterBy="label" id="multiselectStatuses"
                placeholder="Sel. Protocol" [maxSelectedLabels]="1" styleClass="multiSelectionDropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>

          <div class="col-1 pt-2" id="refreshBatchesDiv">
            <button pButton icon="pi pi-times" class="refreshBatches resetButton" (click)="resetAllFilter()"></button>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-11 pt-2" id="multiselectDiv">
            <div class="ui-inputgroup" id="datePicker">
              <button pButton class="theme-button noHover labelButton" type="button" label="Date"></button>
              <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                dateFormat="dd.mm.yy" [showIcon]="true" placeholder="Sel. Start Date" showButtonBar="true"
                (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()">
              </p-calendar>
            </div>
          </div>
          <div class="flex justify-content-between px-0">
            <span class="m-0 col-7 px-0">Number Of Plates Matching Filter:
              <span class="m-0 font-weight-bold text-success" style="font-size: 1.2rem;">{{beadchipPlates == null ? 0: beadchipPlates.length}}</span>
            </span>
            <span class="col-4 m-0 px-0">Show Due Date <p-inputSwitch [(ngModel)]="showDueDate"></p-inputSwitch></span>
          </div>
        </div>
      </div>
      <div class="col-9">
        <div class="col-12 flex" id="topGroup">
          <div class="col-4 topDivspacing pr-0" id="topDiv">
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="User ID"></button>
              <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="userID" maxlength="4" id="puid-field"/>
            </div>
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="Beadchip ID"></button>
              <input pInputText name="SearchPlate" [(ngModel)]="beadChipToSearch" size="10" (keydown.enter)="searchForBeadChip()"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForBeadChip()"></button>
            </div>
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="Sample ID"></button>
              <input pInputText name="SearchSample" [(ngModel)]="sampleToSearch" size="10" (keydown.enter)="searchForSample()"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForSample()"></button>
            </div>
          </div>

          <div class="col-5 topDivspacing pl-0 pr-0" style="text-align:left;" *ngIf ="plateSelection">
              <div class="col-12 flex headers">
                <h5>
                  Plate: <strong>{{selectedPlate?.lastUpdatedPlateID}} </strong>
                </h5>
              </div>
              <div class="col-12 flex headers statusField" id="headerNonTop">
                <h5>
                  Status: <strong> {{selectedPlate?.status}} </strong>
                </h5>
              </div>
              <div class="col-12 flex headers" id="headerNonTop">
                <h5>
                  Sender:<strong> {{selectedPlate?.sender}}</strong>
                </h5>
              </div>
              <div class="col-12 flex headers">
                <h5>
                  Sample-Type: <strong> {{selectedPlate?.sampleType}} </strong>
                </h5>
              </div>
              <div class="col-12 flex headers" id="headerNonTop" style="margin-top:-14px" *ngIf="selectedPlate?.storagePlate">
                <h5>
                  Storage:<strong>{{selectedPlate?.storage}} </strong>
                </h5>
              </div>
          </div>
          <div class="col-5 topDivspacing pl-0 pr-0" style="text-align:left;" *ngIf ="!plateSelection">
            <div class="col-12 flex headers">
              <h5>
                BeadChipID: <strong>{{selectedBeadChipPlate?.plateID}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers statusField" id="headerNonTop">
              <h5>
                Status: <strong> {{selectedBeadChipPlate?.status}} </strong>
              </h5>
            </div>
            <div class="col-12 flex headers" id="headerNonTop">
              <h5>
                SourcePlateID:<strong> {{parseSourcePlates(selectedBeadChipPlate)}}</strong>
              </h5>
            </div>
          </div>
          <div class="col-3">
            <div class="col-12 flex pt-0 pb-0">
              <button pButton icon="pi pi-list" [label]="(beadChipViewSelected || axiom384PlateBool)? 'View Batch' : 'View Beadchip' " *ngIf = "(selectedPlate.plateID || selectedBeadChipPlate.plateID) && !plateSelected"
              (click)="toggleBeadChipView()" class="buttonsRound" id="plateView">
              </button>
            </div>
            <div class="col-12 flex" style="padding-top:0px!important">
              <button pButton icon="fa fa-comment" label="Comments" *ngIf = "selectedPlate.plateID || selectedBeadChipPlate.plateID"
                (click)="showComments()" class="buttonsRound" id="plateView">
              </button>
            </div>
            <div class="col-12 flex">
              <button pButton icon="fa fa-comment" label="Comments" *ngIf="lastUpdatedBeadChips1.length>0 && this.multiBeadChip"
                (click)="showMultiComments()" class="buttonsRound" id="plateView">
              </button>
            </div>
            <div class="col-12 flex p-0 ui-inputgroup">
              <input #manualfileUpload pInputText class="form-control" name="profile" type="file"
                accept=".log" (change)="onFileSelect($event)" id="fileChooser" placeholder="Upload Log Files"
                #fileInput />
              <button pButton icon="fa fa-upload" type="submit" id="uploadButtonExcel"
                (click)="fileUpload()" [disabled]="isFileNotSelected" class="uploadBtn">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class = "tableLHS1">
        <p-table [value]="beadchipPlates" selectionMode="single"  (onRowUnselect) ="removeBeadChipSelection()"
          (onRowSelect)="fetchBeadchip($event)" [loading]="beadChipTableloading" [(selection)]="beadChipSelectedRow">
          <ng-template pTemplate="header">
            <tr style="border: 1px solid lightgray;">
              <th scope="col" style="width: 35%;" class="batch">BeadChip ID<span *ngIf="showDueDate"><br/> (Due Date) </span></th>
              <th scope="col" style="width: 65%;" class="status">Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-beadchip>
            <tr [pSelectableRow]="beadchip">

              <td style="width: 30%;" [ngClass]="getPriorityClass(beadchip?.priority)" class="normalBody text-break pr-0">
                {{beadchip?.plateID}}
                <i class="fa fa-solid fa-star" *ngIf="beadchip?.reRun"></i>
                <span *ngIf="showDueDate"><br/> ({{ convertUtcToLocal(beadchip.dueDate) | date : 'dd.MM.yyyy' }}) </span>
              </td>
              <td style="width: 75%;" [ngClass]="getPriorityClass(beadchip?.priority)" class="normalBody pr-0">
                {{beadchip?.status}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div style=" margin-left: 3%; margin-top: 7%;">
        <label class="m-0">Number Of Plates Matching Filter: <label class="m-0 font-weight-bold text-success"
            style="font-size: 1.2rem;">{{plates == null ? 0: plates.length}}</label></label>
      </div>
      <div class = "tableLHS2">
        <p-table [value]="plates" selectionMode="single"
          (onRowSelect)="fetchPlate($event)" (onRowUnselect)="removePlateSelection()" [loading]="plateTableloading" [(selection)]="tableSelectedRow">
          <ng-template pTemplate="header">
            <tr >
              <th scope="col" style="width: 35%;" class="batch">Plate ID <span *ngIf="showDueDate"><br/> (Due Date) </span></th>
              <th scope="col" style="width: 65%;" class="status">Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-plate>
            <tr [pSelectableRow]="plate">

              <td style="width: 35%;" [ngClass]="getPriorityClass(plate?.priority)" class="normalBody text-break pr-0">
                  <span>{{plate?.lastUpdatedPlateID}}</span>
                  <i *ngIf="plate?.latestUserComment" class="pi pi-comment p-1" [pTooltip]="showLatestComment(plate,datePipe)"></i>
                  <i class="pi pi-star-fill" *ngIf="plate?.reRun"></i>
                  <i class="pi pi-arrow-right-arrow-left p-1" *ngIf="checkStatusChange(plate)"></i>
                <span *ngIf="showDueDate"><br/> ({{ convertUtcToLocal(plate.dueDate) | date : 'dd.MM.yyyy' }}) </span>
              </td>
              <td [ngClass]="getPriorityClass(plate?.priority)" class="normalBody pr-0">
                {{plate?.status}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      </div>
      <div class="col-9">
        <div *ngIf="plateViewSelectionDone && beadChipViewSelected" class="col-12 p-0">
          <app-ma-beadchip-view [selectedBeadchipData]="selectedBeadChipPlate"></app-ma-beadchip-view>
        </div>
        <div *ngIf="plateViewSelectionDone && axiom384PlateBool" class="col-12 p-0">
          <app-ma-beadchip-view [selectedBeadchipData]="beadChipDetails"></app-ma-beadchip-view>
        </div>
        <div class="col-6" id="tableDiv" *ngIf="!plateViewSelectionDone">
          <table aria-describedby="Workflow selection" id="workflowSelection"
            style="border: 1px solid black; width: 100%; height: 100%; table-layout:fixed;">
            <thead id="processingTableHeader">
              <tr>
                <th scope="col">Workflow Selection</th>
              </tr>
            </thead>
            <tbody id="processingTableBody">
              <tr>
                <td id="processingTableBody" style="height: 12rem;">
                  <div class="col-12 parent">
                    <div class="col-12">
                      <div class="col-1">
                      </div>
                      <div class="col-11">
                        <span style="font-size: 1.5em;">Please enter the BeadChip ID with which you want to continue!</span>
                      </div>
                    </div>
                    <div class="col-12 flex">
                      <div class="col-2"></div>
                      <div class="col-8">
                        <div class="ui-inputgroup">
                          <button type="button" pButton class="LHbutton LHButton1" label="BeadChip ID"></button>
                          <input pInputText id="input" [(ngModel)]="beadChipToSearch" class="SearchBox" size="30"
                            (keydown.enter)="workflowSelection()"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="!plateViewSelectionDone" class="d-flex justify-content-start mt-2">
            <div class="ui-inputgroup container" id="datePicker">
              <button pButton style="width: 40px" class="theme-button noHover labelButton" type="button" label="Date"></button>
              <p-calendar [style]="{'width':'100%'}" [(ngModel)]="completeIncubationDate" readonlyInput="true"
                dateFormat="dd.mm.yy" [showIcon]="true" placeholder="Sel. Start Date" showButtonBar="true"
                class="p-1">
              </p-calendar>
              <button pButton label="Sample Sheet" (click)="downloadMultiSampleSheetOnAGivenDate()"
                      class="buttonsRound VioletButtons ml-2 mr-2 mt-2">
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 p-0" *ngIf="plateViewSelectionDone && !beadChipViewSelected && !axiom384PlateBool">
          <div id="tableDiv" *ngIf="selectedProcessFlow == 'AXIOM_384'">
            <app-ma-beadchip-loading-axiom [multiBeadChip]="multiBeadChip" [selectedBeadChipPlate]="selectedBeadChipPlate" [selectedBeadChipStepsMap]="selectedPlateStepsMap"
              [selectedWorkFlow]="selectedWorkFlow" [axiom384Plate1]="axiom384Plate1" [axiom384PlateID1]="axiom384PlateID1" [selectedProcessFlowConfig]="selectedProcessFlowConfig"
              (reloadTableEmitter)="onApplyFilter()" (updateBeadChipDataEmitter)="updateBeadChipData($event)" (plateViewResetEmitter)="plateViewSelectionDone=false"></app-ma-beadchip-loading-axiom>
          </div>
          <div class="tableDiv" *ngIf="selectedProcessFlow == 'OLD_FLOW'">
            <table *ngIf="selectedProcessFlow == 'OLD_FLOW'" aria-describedby="Processing table" id="processingTable2" class="hybridization">
              <tr id="processingTableHeader">
                <th scope="col">Denaturate DNA</th>
                <th scope="col">Load Beadchip</th>
                <th scope="col">Hybridization</th>
                <th scope="col">Staining</th>
              </tr>
              <tr>
                <td rowspan="3" id="processingTableBody">
                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Start Denaturation" class="buttonsRound startButton"
                        (click)="savePlateStatus('DENATURATION_STARTED',0, 'DENATURATE_DNA', '', 0)"
                        [disabled]="disableButton(0, 'DENATURATE_DNA', '', 0)"></button>
                    </div>
                    <div class="col-5 siblingSD" *ngIf="isValidProcessStep('DENATURATE_DNA')">
                      {{getProcessStepStartTimestamp('DENATURATE_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                      {{getProcessStepStartPuid('DENATURATE_DNA')}}
                    </div>

                  </div>

                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Incubate 95°C"
                        (click)="savePlateStatus('INCUBATE_95C',2, 'DENATURATE_DNA', 'INCUBATE_95C', 0)"
                        class="buttonsRound VioletButtons" [disabled]="disableButton(2, 'DENATURATE_DNA', 'INCUBATE_95C', 0)">
                      </button>
                    </div>
                    <div class="col-5 child action-timer-div" *ngIf="isValidProcessStep('DENATURATE_DNA', 'INCUBATE_95C')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('DENATURATE_DNA', 'INCUBATE_95C')}} </span>
                    </div>
                  </div>
                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Incubate RT"
                        (click)="savePlateStatus('INCUBATE_RT',2, 'DENATURATE_DNA', 'INCUBATE_RT', 1)"
                        class="buttonsRound VioletButtons" [disabled]="disableButton(2, 'DENATURATE_DNA', 'INCUBATE_RT', 1)">
                      </button>
                    </div>
                    <div class="col-5 child action-timer-div" *ngIf="isValidProcessStepAction('DENATURATE_DNA', 'INCUBATE_RT')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('DENATURATE_DNA', 'INCUBATE_RT')}} </span>
                    </div>
                  </div>
                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Complete Denatu."
                        (click)="savePlateStatus('DENATURATION_COMPLETED',1, 'DENATURATE_DNA', '', 0)"
                        class="buttonsRound endButton" id="CHbutton"
                        [disabled]="disableButton(1, 'DENATURATE_DNA', '', 0)"></button>
                    </div>
                    <div class="col-5 child" *ngIf="isValidProcessStep('DENATURATE_DNA')">
                      {{getProcessStepEndTimestamp('DENATURATE_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                      {{getProcessStepEndPuid('DENATURATE_DNA')}}
                    </div>
                  </div>
                </td>
                <td rowspan="2" id="processingTableBody">
                  <div class="col-12 parent">
                    <div class="col-5 child ui-inputgroup innerDiv" style="width: 17rem;">
                      <button pButton class="theme-button input noHover labelButton1" type="button" label="WGA Plate ID"></button>
                      <input pInputText id="scan-plate-1" name="SearchPlate" class="check" [(ngModel)]="scannedPlate1.wgaPlateID"
                        placeholder="Scan WGA Plate" (keydown.enter)="searchPlateForBeadchipLoading(scannedPlate1.wgaPlateID, 1)"
                        (change)="searchPlateForBeadchipLoading(scannedPlate1.wgaPlateID, 1)" />
                    </div>
                    <div class="col-12 flex parent">
                      <div class="ui-inputgroup">
                        <button pButton class="theme-button input noHover labelButton1" type="button" label="Array-1"></button>
                        <input pInputText id="scan-beadchip-1-1" name="SearchBeadchip" class="check"
                          [(ngModel)]="scannedPlate1.beadChips[0].beadChipID" placeholder="Scan Array-1"
                          (keydown.enter)="validateBeadchipID(1, 2)" />
                      </div>
                      <div class="ui-inputgroup">
                        <button pButton class="theme-button input noHover labelButton1" type="button" label="Array-2"></button>
                        <input pInputText id="scan-beadchip-1-2" name="SearchBeadchip" class="check"
                          [(ngModel)]="scannedPlate1.beadChips[1].beadChipID" placeholder="Scan Array-2"
                          (keydown.enter)="validateBeadchipID(1, 3)" />
                      </div>
                    </div>
                  </div>
                </td>
                <td rowspan="1" id="processingTableBody">
                  <div class="col-12 flex parent" id="lot-div">
                    <div class="col-9"></div>
                    <div class="col-2 child">
                      <button pButton label="LOT" (click)="showChemicalPopup(false, 'HYBRIDIZATION')"
                        class="buttonsRound1 downLoadButton" type="button"></button>
                    </div>
                  </div>
                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Start Hydrid."
                        (click)="saveBeadChipStatus('HYBRIDIZATION_STARTED', 0, 'HYBRIDIZATION', '', 0)"
                        class="buttonsRound startButton" [disabled]="disableButton(0, 'HYBRIDIZATION', '', 0)"></button>
                    </div>
                    <div class="col-5 timeStamp" *ngIf="isValidProcessStep('HYBRIDIZATION')">
                      {{getProcessStepStartTimestamp('HYBRIDIZATION') | date: 'dd.MM.yy HH:mm'}}
                      <br /> {{getProcessStepStartPuid('HYBRIDIZATION')}}
                    </div>
                  </div>
                  <div class="col-12 parent" id="hybridization-div" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Complete Hybrid."
                        (click)="saveBeadChipStatus('HYBRIDIZATION_COMPLETED',1, 'HYBRIDIZATION', '', 0)"
                        class="buttonsRound endButton" id="CHbutton" [disabled]="disableButton(1, 'HYBRIDIZATION', '', 0)"></button>
                    </div>
                    <div class="col-5" id="completeHybridTimestamp" *ngIf="isValidProcessStep('HYBRIDIZATION')">
                      {{getProcessStepEndTimestamp('HYBRIDIZATION') | date: 'dd.MM.yy HH:mm'}}
                      <br /> {{getProcessStepEndPuid('HYBRIDIZATION')}}
                    </div>
                  </div>
                </td>
                <td rowspan="1" id="processingTableBody">

                  <div class="col-12 flex parent" id="lot-div">
                    <div class="col-9"></div>
                    <div class="col-2 child">
                      <button pButton label="LOT" (click)="showChemicalPopup(false, 'STAINING')"
                        class="buttonsRound1 downLoadButton" type="button"></button>
                    </div>
                  </div>
                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Start Staining" (click)="saveBeadChipStatus('STAINING_STARTED', 0, 'STAINING', '', 0)"
                        class="buttonsRound startButton" [disabled]="disableButton(0, 'STAINING', '', 0)"></button>
                    </div>
                    <div class="col-5 timeStamp" *ngIf="isValidProcessStep('STAINING')">
                      {{getProcessStepStartTimestamp('STAINING') | date: 'dd.MM.yy HH:mm'}}
                      <br /> {{getProcessStepStartPuid('STAINING')}}
                    </div>
                  </div>
                  <div class="col-12 parent" id="hybridization-div" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Complete Staining."
                        (click)="saveBeadChipStatus('STAINING_COMPLETED',1, 'STAINING', '', 0)" class="buttonsRound endButton"
                        id="CHbutton" [disabled]="disableButton(1, 'STAINING', '', 0)"></button>
                    </div>
                    <div class="col-5" id="completeHybridTimestamp" *ngIf="isValidProcessStep('STAINING')">
                      {{getProcessStepEndTimestamp('STAINING') | date: 'dd.MM.yy HH:mm'}}
                      <br /> {{getProcessStepEndPuid('STAINING')}}
                    </div>
                  </div>

                </td>
              </tr>
              <tr id="processingTableHeader">
                <th class="secondHeader" scope="col">Incubation</th>
                <th class="secondHeader" scope="col">Drying</th>
              </tr>
              <tr>
                <td rowspan="2" id="processingTableBody">
                  <div class="col-12 flex parent">
                    <div class="col-5 child ui-inputgroup innerDiv" style="width: 17rem;">
                      <button pButton class="theme-button input noHover labelButton1" type="button" label="WGA Plate ID"></button>
                      <input pInputText id="scan-plate-2" name="SearchPlate" class="check" [(ngModel)]="scannedPlate2.wgaPlateID"
                        placeholder="Scan WGA Plate" (keydown.enter)="searchPlateForBeadchipLoading(scannedPlate2.wgaPlateID, 2)"
                        (change)="searchPlateForBeadchipLoading(scannedPlate2.wgaPlateID, 2)" />
                    </div>
                    <div class="col-12 flex parent">
                      <div class="ui-inputgroup">
                        <button pButton class="theme-button input noHover labelButton1" type="button" label="Array-1"></button>
                        <input pInputText id="scan-beadchip-2-1" name="SearchBeadchip" class="check"
                          [(ngModel)]="scannedPlate2.beadChips[0].beadChipID" placeholder="Scan Array-1"
                          (keydown.enter)="validateBeadchipID(2, 2)" />
                      </div>
                      <div class="ui-inputgroup">
                        <button pButton class="theme-button input noHover labelButton1" type="button" label="Array-2"></button>
                        <input pInputText id="scan-beadchip-2-2" name="SearchBeadchip" class="check"
                          [(ngModel)]="scannedPlate2.beadChips[1].beadChipID" placeholder="Scan Array-2"
                          (keydown.enter)="validateBeadchipID(2, 3)" />
                      </div>
                    </div>
                  </div>
                </td>
                <td rowspan="4" id="processingTableBody">
                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Start Incubation"
                        (click)="saveBeadChipStatus('INCUBATION_STARTED', 0, 'INCUBATION', '', 0)" class="buttonsRound startButton"
                        [disabled]="disableButton(0, 'INCUBATION', '', 0)"></button>
                    </div>
                    <div class="col-5 timeStamp" *ngIf="isValidProcessStep('INCUBATION')">
                      {{getProcessStepStartTimestamp('INCUBATION') | date: 'dd.MM.yy HH:mm'}}
                      <br /> {{getProcessStepStartPuid('INCUBATION')}}
                    </div>
                  </div>
                  <div class="col-12 flex parent" id="input1">
                    <div class="ui-4-child ui-inputgroup">
                      <button pButton class="theme-button noHover labelButton" type="button" label="Oven-ID"
                        style="width: 9rem;"></button>
                      <input style="width: 8rem;height: 35px;" pInputText class="inputButton"
                      [(ngModel)]="incubationOvenId"
                      [value]="getProcessStepActionLiquidHandler('INCUBATION','INCUBATE_58C')"
                      [disabled]="disableButton(2, 'INCUBATION', '', 0)" />
                    </div>
                  </div>
                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Incubate 58°C"
                        (click)="saveBeadChipStatus('INCUBATE_58C',2, 'INCUBATION', 'INCUBATE_58C', 0)"
                        class="buttonsRound VioletButtons" [disabled]="disableButton(2, 'INCUBATION', 'INCUBATE_58C', 0)">
                      </button>
                    </div>
                    <div class="col-5 child action-timer-div" *ngIf="isValidProcessStep('INCUBATION', 'INCUBATE_58C')">
                      <span class="action-timer-span">{{calculateRemainingTimeForAction('INCUBATION', 'INCUBATE_58C')}} </span>
                    </div>
                  </div>
                  <div class="col-12 parent" id="hybridization-div" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Complete Incub."
                        (click)="saveBeadChipStatus('INCUBATION_COMPLETED',1, 'INCUBATION', '', 0)" class="buttonsRound endButton"
                        id="CHbutton" [disabled]="disableButton(1, 'INCUBATION', '', 0)"></button>
                    </div>
                    <div class="col-5" id="completeHybridTimestamp" *ngIf="isValidProcessStep('INCUBATION')">
                      {{getProcessStepEndTimestamp('INCUBATION') | date: 'dd.MM.yy HH:mm'}}
                      <br /> {{getProcessStepEndPuid('INCUBATION')}}
                    </div>
                  </div>
                </td>
                <td rowspan="1" id="processingTableBody">
                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Start Drying" (click)="saveBeadChipStatus('DRYING_STARTED', 0, 'DRYING', '', 0)"
                        class="buttonsRound startButton" [disabled]="disableButton(0, 'DRYING', '', 0)"></button>
                    </div>
                    <div class="col-5 timeStamp" *ngIf="isValidProcessStep('DRYING')">
                      {{getProcessStepStartTimestamp('DRYING') | date: 'dd.MM.yy HH:mm'}}
                      <br /> {{getProcessStepStartPuid('DRYING')}}
                    </div>
                  </div>
                  <div class="col-12 parent" id="hybridization-div" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Complete Drying" (click)="saveBeadChipStatus('DRYING_COMPLETED',1, 'DRYING', '', 0)"
                        class="buttonsRound endButton" id="CHbutton" [disabled]="disableButton(1, 'DRYING', '', 0)"></button>
                    </div>
                    <div class="col-5" id="completeHybridTimestamp" *ngIf="isValidProcessStep('DRYING')">
                      {{getProcessStepEndTimestamp('DRYING') | date: 'dd.MM.yy HH:mm'}}
                      <br /> {{getProcessStepEndPuid('DRYING')}}
                    </div>
                  </div>
                </td>
              </tr>
              <tr id="processingTableHeader">
                <th class="secondHeader" scope="col">Last Updated</th>
                <th class="secondHeader" scope="col">Evaluation</th>
              </tr>
              <tr>
                <td rowspan="2" id="processingTableBody">
                  <table class="last-updated-table">
                    <tr *ngFor="let updatedBeadChip of lastUpdatedBeadChips1; let i=index">
                      <td>{{updatedBeadChip.entityId}}</td>
                      <td>{{lastUpdatedBeadChips2[i].entityId}}</td>
                      <td>{{lastUpdatedBeadChips3[i].entityId}}</td>
                    </tr>
                    <tr>
                  </table>
                </td>
                <td rowspan="2" id="processingTableBody">
                  <div class="col-12 flex parent">
                    <div class="col-5 child ui-inputgroup innerDiv" style="width: 17rem;">
                      <button pButton class="theme-button input noHover labelButton1" type="button" label="WGA Plate ID"></button>
                      <input pInputText id="scan-plate-3" name="SearchPlate" class="check" [(ngModel)]="scannedPlate3.wgaPlateID"
                        placeholder="Scan WGA Plate" (keydown.enter)="searchPlateForBeadchipLoading(scannedPlate3.wgaPlateID, 3)"
                        (change)="searchPlateForBeadchipLoading(scannedPlate3.wgaPlateID, 3)" />
                    </div>
                    <div class="col-12 flex parent">
                      <div class="ui-inputgroup">
                        <button pButton class="theme-button input noHover labelButton1" type="button" label="Array-1"></button>
                        <input pInputText id="scan-beadchip-3-1" name="SearchBeadchip" class="check"
                          [(ngModel)]="scannedPlate3.beadChips[0].beadChipID" placeholder="Scan Array-1"
                          (keydown.enter)="validateBeadchipID(3, 2)" />
                      </div>
                      <div class="ui-inputgroup">
                        <button pButton class="theme-button input noHover labelButton1" type="button" label="Array-2"></button>
                        <input pInputText id="scan-beadchip-3-2" name="SearchBeadchip" class="check"
                          [(ngModel)]="scannedPlate3.beadChips[1].beadChipID" placeholder="Scan Array-2"
                          (keydown.enter)="validateBeadchipID(3, 3)" />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 flex parent">
                    <div class="col-8"></div>
                    <div class="col-3 child loadBeadchipButton" style="margin-left: 8rem;">
                      <button pButton label="Load Beadchip" class="buttonsRound startButton"
                        [disabled]="disableLoadBeadchipButton()" (click)="loadBeadChips()"></button>
                    </div>
                  </div>
                  <div class="col-12 flex parent">
                    <div class="col-3 child loadBeadchipButton" style="margin-left: 8rem;">
                      <button pButton label="Store WGA Plate"
                        class="buttonsRound otherbutton" (click)="showWgaStoreDialog()">
                      </button>
                    </div>
                  </div>
                </td>
                <td rowspan="2" id="processingTableBody">
                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Sample Sheet" (click)="downloadSampleSheet()" [disabled] = "disableShampleSheet()"
                        class="buttonsRound VioletButtons">
                      </button>
                    </div>
                  </div>
                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Image BeadChip" (click)="saveBeadChipStatus('BEADCHIP_IMAGED',0, 'EVALUTION', '', 0)"
                        class="buttonsRound startButton" [disabled]="disableButton(0, 'EVALUTION', '', 0)">
                      </button>
                    </div>
                    <div class="col-5" id="completeHybridTimestamp" *ngIf="isValidProcessStep('EVALUTION')">
                      {{getProcessStepStartTimestamp('EVALUTION') | date: 'dd.MM.yy HH:mm'}}
                      <br /> {{getProcessStepStartPuid('EVALUTION')}}
                    </div>
                  </div>
                  <div class="col-12 parent" style="flex-direction: unset;">
                    <div class="col-8 child">
                      <button pButton label="Resultfiles Sent" (click)="saveBeadChipStatus('COMPLETED',1, 'EVALUTION', '', 0)"
                        class="buttonsRound otherbutton" [disabled]="disableButton(1, 'EVALUTION', '', 0)">
                      </button>
                    </div>
                    <div class="col-5" id="completeHybridTimestamp" *ngIf="isValidProcessStep('EVALUTION')">
                      {{getProcessStepEndTimestamp('EVALUTION') | date: 'dd.MM.yy HH:mm'}}
                      <br /> {{getProcessStepEndPuid('EVALUTION')}}
                    </div>
                  </div>

                </td>
              </tr>
            </table>
            <div class="d-flex justify-content-end mt-2">
              <div class="ui-inputgroup" id="datePicker">
                <button pButton class="theme-button noHover labelButton" type="button" label="Date"></button>
                <p-calendar [style]="{'width':'33%'}" [(ngModel)]="completeIncubationDate" readonlyInput="true"
                  dateFormat="dd.mm.yy" [showIcon]="true" placeholder="Sel. Start Date" showButtonBar="true"
                  class="p-1">
                </p-calendar>
                <button pButton label="Sample Sheet" (click)="downloadMultiSampleSheetOnAGivenDate()" [disabled] = "disableShampleSheet()"
                        class="buttonsRound VioletButtons ml-2 mr-2">
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Multiple BeadChips Update" [(visible)]="showConfirmBeadChipsPopup" showEffect="fade" position="top"
    [modal]="true" [style.width]="'325px'" [contentStyle]="{'max-height':'70vh'}">
    <div class="content-in-multi-update-popup">
    <table id="scanTable" aria-describedby="View Plates" class="table">
      <tr>
        <input pInputText name="plateId" [(ngModel)]="enteredBeadChipId" id="popup-beadchipid" (keydown.enter)="checkBeadChip()"
          [placeholder]="multiUpdateInputLabel" />
      </tr>
      <tr *ngFor="let beadChip of multiUpdateBeadChipList;">
        <input pInputText name="plateId" [value]="beadChip"  id="plateid" readonly />
        <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteBeadChipFromMultiUpdateList(index,'popup-beadchipid')"></button>
      </tr>
    </table>
  </div>
    <div>
      <button pButton [label]="multiUpdateStatusLabel" (click)="updateMultiBeadChips()" class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass"
        [disabled]="multiUpdateBeadChipList.length ==0">
      </button>
    </div>
</p-dialog>

<p-dialog header="Multiple Plate Update" [(visible)]="showConfirmPlatesPopup" showEffect="fade" position="top"
    [modal]="true" [style.width]="'325px'" [contentStyle]="{'max-height':'70vh'}">
    <div class="content-in-multi-update-popup">
      <table id="scanTable" aria-describedby="View Plates" class="table">
        <tr>
          <input pInputText name="plateId" [(ngModel)]="enteredPlateId" id="popup-plateid" (keydown.enter)="checkPlate()"
            [placeholder]="multiUpdateInputLabel" />
        </tr>
        <tr *ngFor="let plate of multiUpdatePlateList;">
          <input pInputText name="plateId" [value]="plate" id="plateid" readonly />
          <button pButton icon="fa fa-times-circle" class="removePopInput"
            (click)="deletePlateFromMultiUpdateList(index)"></button>
        </tr>
      </table>
    </div>
    <div>
      <button pButton [label]="multiUpdateStatusLabel" (click)="updateMultiPlates()" class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass"
        [disabled]="multiUpdatePlateList.length ==0">
      </button>
    </div>
</p-dialog>

<p-dialog header="Chemicals" [(visible)]="showDialogue" [focusOnShow]="true" [modal]="true" [style.width]="'800px'" position="top" (onHide)="hideChemicalDialog(selectedBeadChipPlate)">
  <app-ma-chemicals-popup [selectedPlate]="selectedBeadChipPlate" [selectedProcessStep]="selectedProcessStep" [processStepChemicals]="processStepChemicals" [noChemicalEdit]="noChemicalEdit"
    [multiChemicals]="multiChemicalEdit" [plateids]="chemicalsBeadChipids" [isPlate]="true" [dialogOpen]="showDialogue" (backButtonEmitter)="hideChemicalDialog($event)"></app-ma-chemicals-popup>
</p-dialog>

<p-dialog header="Add Comments" [(visible)]="showMultipleCommentDialog" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}">
  <div class="col-12 flex mt-0" id="commentTextAreDiv">
    <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..." [(ngModel)]="newMultiComment"></textarea>
  </div>
  <div class="col-12 flex mt-2 addCommentButton">
    <button pButton label="Add Comment" [disabled]="(newMultiComment == null || newMultiComment.trim() == '')" (click)="saveMultiComment()"></button>
  </div>
</p-dialog>

<p-dialog header="{{commentplateID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true" position="top" [contentStyle]="{'max-height':'70vh'}">
  <app-ma-comments-popup [selectedPlateID]="selectedPlateID" [selectedPlateStatus]="selectedPlateStatus" [selectedBeadchipStatus]="selectedBeadchipStatus" [plateCommentList] = "plateCommentsList"  [beadChipCommentsDisplayMap]="beadChipCommentsDisplayMap" [beadChipCommentsMap]="beadChipCommentsMap" [beadChipID] ="selectedBeadChipPlate.plateID"  (backButtonEmitter)="hideDialog($event)"></app-ma-comments-popup>
</p-dialog>

<p-dialog header="Store WGA Plate" [(visible)]="wgaStoreDialog" showEffect="fade" [modal]="true" width="fit-content" position="top" (onHide)="closeStorageDialog()">
  <div class="col-12 flex">
    <table>
      <thead class="tableBorderNone">
        <tr class="tableBorderNone">
          <th colspan="2" class="tableBorderNone mt-3 mb-3">
            <span style="font-weight:700;">Scan Plates for storage</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="tableBorderNone">
          <td colspan="2" class="ui-inputgroup" class="tableBorderNone" style="margin-bottom: 1rem !important;">
            <button pButton class="theme-button noHover storageTypeBtn" style="width: 11rem !important;" type="button" label="Storage Location"></button>
            <p-dropdown [options]="longtimeStorageList" [(ngModel)]="selectedStorageLocation" optionLabel="storageName" optionValue="storageName" placeholder="Storage Location" [style]="{'width': '17rem'}">
            </p-dropdown>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="tableBorderNone">
            <input pInputText name="plateId" [(ngModel)]="enteredWgaPlateID" id="store-plate-id" (keydown.enter)="checkIfPlateExists()" placeholder="Scan Plates" />
          </td>
        </tr>
        <tr *ngFor="let plate of multiWgaPlateID; let i = index;">
          <td>
            <input pInputText name="plateId" [value]="plate" id="plateid" readonly />
          </td>
          <td>
            <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="removePlateFromStoreList(i)"></button>
          </td>
        </tr>
        <tr class="mt-2 mb-2 col-12 d-flex justify-content-center">
          <td colspan="2">
            <button class="theme-button labelButton" style="width: 100%;" pButton label="Store" (click)="addMultiPlateToStorage()"></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</p-dialog>
